import { render, staticRenderFns } from "./Exposure.vue?vue&type=template&id=4b8aed7c&scoped=true"
import script from "./Exposure.vue?vue&type=script&lang=js"
export * from "./Exposure.vue?vue&type=script&lang=js"
import style0 from "./Exposure.vue?vue&type=style&index=0&id=4b8aed7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8aed7c",
  null
  
)

export default component.exports